module.exports = __webpack_public_path__ + "img/icon_category_00.69379b14.svg";